import { render, staticRenderFns } from "./marconfirmflow.vue?vue&type=template&id=3ca8ca7e&lang=pug&"
import script from "./marconfirmflow.vue?vue&type=script&lang=js&"
export * from "./marconfirmflow.vue?vue&type=script&lang=js&"
import style0 from "./marconfirmflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports